const CHARACTERS = [
	...[...Array(10)].map((_, i) => String.fromCharCode(48 + i)), // 0-9
	...[...Array(26)].map((_, i) => String.fromCharCode(65 + i)), // A-Z
	...[...Array(26)].map((_, i) => String.fromCharCode(97 + i)), // a-z
]

export const VAR_LENGTH = 5

export default function generateRandomVariableName() {
	let result = ''

	for (let i = 0; i < VAR_LENGTH; i++) {
		result += CHARACTERS[Math.floor(Math.random() * CHARACTERS.length)]
	}

	return result
}
